/**
 *
 * Asynchronously loads the component for CreatedProgram
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
